import { AxiosResponse } from 'axios';
import { USERS_API_URL } from '../../../../config';
import userAxios from '../../../../utils/axios/user.axios';

const tryToFetchDemoRequests = (
    pageNumber: number,
    pageSize: number,
    data?: any,
    filters?: string,
): Promise<AxiosResponse<any>> => {
    const url = filters
        ? `${USERS_API_URL}/demo-requests?page=${pageNumber}&size=${pageSize}&search=${filters}`
        : `${USERS_API_URL}/demo-requests?page=${pageNumber}&size=${pageSize}`;
    return userAxios.put<any>(url, data);
};

const tryToEditDemoRequestStatus = (data: any): Promise<AxiosResponse<any>> => {
    return userAxios.put(`${USERS_API_URL}/demo-requests/${data?.id}/update/${data?.status}`);
};

const tryToInviteNewMember = (data: any): Promise<AxiosResponse<any>> => {
    return userAxios.put(`${USERS_API_URL}/demo-requests/invite/by-email`, data);
};

export const DemoRequestsService = {
    tryToFetchDemoRequests,
    tryToInviteNewMember,
    tryToEditDemoRequestStatus,
};